// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2SOTv","form":"styles_form__1OKay"};